(() => {
  const guide = document.querySelector('[data-sjd-guide]');
  if (!guide) return;

  const cards = [...guide.querySelectorAll('[data-sjd-guide-card]')];
  const filters = [...guide.querySelectorAll('[data-sjd-guide-filter]')];
  const emptyState = guide.querySelector('[data-sjd-guide-empty]');
  const status = guide.querySelector('[data-sjd-guide-status]');

  const update = (selectedTag) => {
    let visibleCount = 0;

    cards.forEach((card) => {
      const topics = `|${card.dataset.guideTopics || ''}|`;
      const visible = selectedTag === 'all' || topics.includes(`|${selectedTag}|`);
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (emptyState) emptyState.hidden = visibleCount !== 0;
    if (status) status.textContent = selectedTag === 'all' ? '' : `${visibleCount} guide${visibleCount === 1 ? '' : 's'}`;

    filters.forEach((filter) => {
      const active = filter.dataset.sjdGuideFilter === selectedTag;
      filter.classList.toggle('is-active', active);
      filter.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  filters.forEach((filter) => {
    filter.addEventListener('click', () => update(filter.dataset.sjdGuideFilter));
  });
})();
